<div class="h-screen min-h-screen w-full mx-auto px-4 flex flex-col" *ngIf="config">

  <div class="flex-none mx-auto" id="logo-wrapper">
    <img [src]="getLogoUrl()" alt="Logo" class="logo-image">
  </div>

  <div class="grid grid-cols-1 grid-flow-row gap-4 w-full md:mx-auto py-6 overflow-y-auto" *ngIf="assets" (scroll)="onScroll($event)">
    <div class="relative w-full job" *ngFor="let job of jobs">
      <div class="flex flex-row justify-between">
        <span>Status: {{ selectedJobs[job.id].status }}</span>
        <span class="text-right">Created: {{ job.createdAt | dfnsFormatDistanceToNow: { addSuffix: true } }}</span>
      </div>
      <div class="relative overflow-hidden rounded-lg aspect-square my-1">

        <button type="button" class="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" (click)="previous(job.id)">
          <span class="inline-flex items-center justify-center w-10 h-10 rounded-full slider-wrapper">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10" class="w-4 h-4 rtl:rotate-180 slider-button"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 1 1 5l4 4"></path></svg>
            <span class="sr-only">Previous</span>
          </span>
        </button>

        <ng-container *ngFor="let asset of filterOutputOnly(job.assets); index as i">
          <div class="item" [class.hidden]=" ! isSelected(job.id, i)">
            <img [src]="asset.url" [default]="defaultImage" class="absolute block aspect-square object-contain ios-downloadable h-full w-full" alt="AI Generated Image" [attr.data-id]="job.id" [attr.data-index]="i">
          </div>
        </ng-container>

        <button type="button" class="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none" (click)="next(job.id)">
          <span class="inline-flex items-center justify-center w-10 h-10 rounded-full slider-wrapper">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10" class="w-4 h-4 slider-button rtl:rotate-180">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"></path>
            </svg>
            <span class="sr-only">Next</span>
          </span>
        </button>

      </div>
      <div class="flex flex-row justify-between">
        <button class="p-4 text-white bg-black bg-opacity-50" (click)="toggle(job.id)" *ngIf="selectedJobs[job.id]?.status == 'hidden'">Show</button>
        <button class="p-4 text-white bg-black bg-opacity-50" (click)="toggle(job.id)" *ngIf="selectedJobs[job.id]?.status != 'hidden'">Hide</button>
        <button class="p-4 text-white bg-black bg-opacity-50" (click)="showQrCode(job.id)">QR Code</button>
      </div>
    </div>
  </div>

  <div class="aspect-square absolute top-0 left-0 vh-100" *ngIf="jobId">
    <img [src]="getQRCode(jobId)" alt="QR Code" class="border-[2rem] border-white rounded-xl w-full">
    <button class="absolute bottom-1 right-1 p-4 text-white bg-black bg-opacity-50" (click)="hideQrCode()">Dismiss</button>
  </div>

  <content-block [slug]="'default-disclaimer-bottom'" id="default-disclaimer-bottom-wrapper"></content-block>
</div>

